import ModalProvider from './ModalProvider';

export default ModalProvider;
